// extracted by mini-css-extract-plugin
export var closeButton = "_in-2";
export var closeButtonIcon = "_in-3";
export var lightboxContent = "_in-1";
export var lightboxOverlay = "_in-0";